var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"question text-bold",style:({color: _vm.rgbaToCss(_vm.dataColor)})},[_vm._v("\n    "+_vm._s(_vm.dataHeading)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }